import {VehicleBrand} from './vehicle-brand';
import {Country} from './country';

export type CountryBrand = 'ToyotaGermany' | 'ToyotaAustria' | 'LexusGermany' | 'LexusAustria'

export class LegalEntity {
  name: string;
  department: string;
  city: string;
  phone: string;
  email: string;
  countryBrand: CountryBrand;
  impressumUrl: string;

  constructor(
    public country: Country,
    public vehicleBrand: VehicleBrand
  ) {
    this.countryBrand = (vehicleBrand.nameForCountryBrand + country.nameForCountryBrand) as CountryBrand;
    const values = LegalEntitiesData[this.countryBrand];
    this.name = values.name;
    this.department = values.department;
    this.city = values.city;
    this.phone = values.phone;
    this.email = values.email;
    this.impressumUrl = values.impressumUrl;
  }

  static get ToyotaGermany(): LegalEntity {
    return new LegalEntity(Country.DE, VehicleBrand.TOYOTA);
  }

  static from(brand: VehicleBrand, country: Country): LegalEntity {
    return new LegalEntity(country, brand);
  }

  isAustria() {
    return this.countryBrand === 'ToyotaAustria' || this.countryBrand === 'LexusAustria';
  }
}

export const LegalEntitiesData = {
  ToyotaGermany: {
    name: 'TOYOTA Deutschland GmbH',
    department: 'Kundenbetreuung Einwilligungsverwaltung',
    city: '50420 Köln',
    phone: '+49 (0)2234 102 7575',
    email: 'einwilligung@toyota.de',
    impressumUrl: 'https://www.toyota.de/legal/impressum'
  },
  ToyotaAustria: {
    name: 'Toyota Austria GmbH',
    department: 'Kundenbetreuung Einwilligungsverwaltung',
    city: '1100 Wien',
    phone: '0502141 150',
    email: 'einwilligung@toyota.at',
    impressumUrl: 'https://www.toyota.at/legal/impressum'
  },
  LexusGermany: {
    name: 'Lexus Deutschland',
    department: 'Lexus Kundenbetreuung - Einwilligungsverwaltung',
    city: '50420 Köln',
    phone: '+49 (0)2234 102 7575',
    email: 'einwilligung@lexus.de',
    impressumUrl: 'https://www.lexus.de/resources/impressum'
  },
  LexusAustria: {
    name: 'Lexus Austria',
    department: 'Lexus Kundenbetreuung Einwilligungsverwaltung',
    city: '1100 Wien',
    phone: '0502141 150',
    email: 'einwilligung@lexus.at',
    impressumUrl: 'https://www.lexus.at/resources/impressum'
  }
}
